import React, { useEffect, useState } from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import { RiFileExcel2Line } from "react-icons/ri";
import DownloadHandler from "../utils/downloadHandler";
import {useDispatch} from "react-redux";
import Loader from "../components/Loader";
import {Table, TableContainer, Tbody, Td, Thead, Tr, useDisclosure} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {getJalaliDate} from "../utils/dateConversion";
import DiscountModal from "../components/DiscountModal";
import {toast} from "react-toastify";

function Discounts() {
  const [discounts, setDiscounts] = useState([]);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setRefresh(false)
      try {
        const response = await api.get(`/api/discounts?page=${currentPage}`);
        setDiscounts(response.data.data);
        setCurrentPage(response.data.current_page);
        setStartIndex(response.data.from);
        setLastPage(response.data.last_page);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    if(refresh)
      fetchData();
  }, [currentPage,refresh]);

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const toggleStatus = async (discountId) =>{
    setLoading(true)
    try {
      const response = await api.post(`/api/discount/toggle/${discountId}`);
      setDiscounts((prevDiscounts) =>
          prevDiscounts.map((discount, i) => ({
            ...discount,
            status: discount.id === discountId ? (response.data.active ? 1 : 0) : discount.status,
          }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      setLoading(false)
    }
  }
  if (loading) return <Loader />
  if (error) return <ErrorPage error={error} />;
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div
        className="table-container flex-fill d-flex flex-column justify-content-between"
        style={{ borderTop: "3px solid #EAEAEA" }}
      >
        <TableContainer>
          <Table variant="striped" colorScheme="teal">
            <Thead>
              <Tr>
                <Td>ردیف</Td>
                <Td>کد تخفیف</Td>
                <Td>محصول</Td>
                <Td>مبلغ</Td>
                <Td>وضعیت</Td>
              </Tr>
            </Thead>
            <Tbody>
              {discounts.length > 0 && discounts.map((discount, index) => (
                  <Tr>
                    <Td>{toPersianNumber(startIndex+index)}</Td>
                    <Td>{toPersianNumber(discount.code)}</Td>
                    <Td>{toPersianNumber(discount.product_name)}</Td>
                    <Td>
                      {toPersianNumber(discount.discount_amount)}%
                      ({discount.product_id !==0 && toPersianNumber(discount.product_price*discount.discount_amount/100)} تومان)</Td>
                    <Td>
                      <button
                          className={`btn ${
                              discount.status === 1
                                  ? "btn-outline-green"
                                  : "btn-outline-red"
                          }`}
                          onClick={() => {
                            toggleStatus(discount.id);
                          }}
                      >
                        {discount.status == 1 ? "فعال" : "غیرفعال"}
                      </button>
                    </Td>
                  </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <div className="py-2 d-flex justify-content-center gap-3">
          <button
              className={`btn btn-outline-orange`}
              disabled={1 === currentPage}
              onClick={() => {
                setCurrentPage(1)
              }}
          >
            صفحه اول
          </button>
          <button
              className={`btn btn-outline-blue`}
              disabled={currentPage === 1}
              onClick={handlePrevPage}
          >
            صفحه قبل
          </button>
          <button
              className={`btn btn-outline-blue`}
              disabled={lastPage === currentPage}
              onClick={handleNextPage}
          >
            صفحه بعد
          </button>
          <button
              className={`btn btn-outline-orange`}
              disabled={lastPage === currentPage}
              onClick={() => {
                setCurrentPage(lastPage)
              }}
          >
            صفحه آخر
          </button>
          <button className={`btn btn-outline-orange d-flex align-items-center gap-1`} onClick={onOpen}>
            افزودن کد تخفیف
          </button>
          <DiscountModal isOpen={isOpen} onClose={onClose} setRefresh={setRefresh}/>
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default Discounts;
